/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PolygonSelectModel } from './polygon-select.model';
import { UpdateSelectionMode } from './polygon-select.actions';
import { DashGisUtil } from '../../../../shared/dash-gis-util';
import { Injectable } from '@angular/core';

@State<PolygonSelectModel>({
    name: 'selectionMode',
    defaults: {
        mode: 'Intersects',
    }
})
@Injectable()
export class PolygonSelectState {

    @Selector()
    static getMode(state: PolygonSelectModel) {
        return state.mode;
    }

    @Action(UpdateSelectionMode)
    setMode({getState, setState}: StateContext<PolygonSelectModel>, action: UpdateSelectionMode) {
        const state = DashGisUtil.clone(getState());
        state.mode = action.payload.mode;
        setState(state);
    }
}
